import { Button } from '@atoms';
import DriveFileRenameOutlineSharpIcon from '@mui/icons-material/DriveFileRenameOutlineSharp';

interface IButtonProps {
  onClick: () => void;
}
const EditButton = ({ onClick }: IButtonProps) => {
  return (
    <Button
      onClick={onClick}
      sx={{ paddingX: '30px' }}
      variant="outlined"
      color="black"
      startIcon={<DriveFileRenameOutlineSharpIcon />}
    >
      Edit
    </Button>
  );
};
export default EditButton;
